import { render, staticRenderFns } from "./SelectInputFiltersNoNotch.vue?vue&type=template&id=2f870d33&scoped=true&"
import script from "./SelectInputFiltersNoNotch.vue?vue&type=script&lang=js&"
export * from "./SelectInputFiltersNoNotch.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputFiltersNoNotch.vue?vue&type=style&index=0&id=2f870d33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f870d33",
  null
  
)

export default component.exports